import { useEffect } from "react";

/**
 * 设置页面标题与描述，用于各页面独立的 TDK。
 */
export function useDocumentMeta(title: string, description?: string) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}